import styled from 'styled-components';

const StyledRoot = styled.div``;

const StyledHeading = styled.h3`
  margin: 0 0 1.25rem;
`;

const StyledSection = styled.div`
  margin-bottom: 1rem;
`;

const StyledFieldLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.textSecondary};
  display: block;
  margin-bottom: 0.375rem;
`;

const StyledSelectorRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const StyledConfigSelect = styled.select`
  flex: 1;
`;

const StyledEmptyHint = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 13px;
  margin: 0 0 1rem;
  font-weight: 300;
`;

const StyledEditorCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderMuted};
  border-radius: ${({ theme }) => theme.radii.md};
  padding: 1.25rem;
  margin-top: 1rem;
  background: ${({ theme }) => theme.colors.surfaceMuted};
`;

const StyledEditorTitle = styled.h4`
  margin: 0 0 1rem;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const StyledFieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
`;

const StyledField = styled.div``;

const StyledTextInput = styled.input`
  width: 100%;
`;

const StyledButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  padding-top: 0.25rem;
`;

const StyledEditHint = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0;
  font-weight: 300;
`;

export default {
  StyledRoot,
  StyledHeading,
  StyledSection,
  StyledFieldLabel,
  StyledSelectorRow,
  StyledConfigSelect,
  StyledEmptyHint,
  StyledEditorCard,
  StyledEditorTitle,
  StyledFieldStack,
  StyledField,
  StyledTextInput,
  StyledButtonRow,
  StyledEditHint,
};
